
import { CellError } from '../Cell';
/**
 * Represents a cell that contains a parsing error.
 */
export class ParsingErrorVertex {
    /**
     * Constructor
     */
    constructor(errors, rawInput) {
        this.errors = errors;
        this.rawInput = rawInput;
    }
    /**
     * Returns the value of the cell.
     */
    getCellValue() {
        const firstNonemptyMessage = this.errors.map(error => error.message).find((msg) => msg);
        return CellError.parsingError(firstNonemptyMessage);
    }
    /**
     * Returns the formula of the cell.
     */
    getFormula() {
        return this.rawInput;
    }
}
